






































































import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
class SettingsPanel extends Vue {
  @Prop({ type: Boolean, default: true }) translate!: boolean;
  @Prop({ type: Boolean, default: true }) edit!: boolean;
  @Prop({ type: Boolean, default: true }) deleted!: boolean;
  @Prop({ type: Boolean, default: false }) forceDelete!: boolean;
  @Prop({ type: Boolean, default: true }) restore!: boolean;
  @Prop({ type: Boolean, default: true }) open!: boolean;

  get showDelete(): boolean {
    return this.deleted;
  }
}
export default SettingsPanel;
